<div class="body">

    <div class="overlay" *ngIf="sending$|async" @fade>

        <mat-spinner [diameter]="50"></mat-spinner>

    </div>

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>alternate_email</mat-icon>
        </button>
        <span>Mail senden</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <app-notification-builder></app-notification-builder>

    </div>

    <div class="footer">

        <button mat-raised-button color="primary" (click)="sendMails()">
            Absenden
        </button>

    </div>

</div>
